// extracted by mini-css-extract-plugin
export var imglyTypoButton = "style-module--imgly--typo-button--n2I-f";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--htXAc";
export var imglyTypoH1 = "style-module--imgly--typo-h1--g4sbh";
export var imglyTypoH2 = "style-module--imgly--typo-h2--ctMds";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--LKBUP";
export var imglyTypoH3 = "style-module--imgly--typo-h3--gWi3f";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--qTmWc";
export var imglyTypoH4 = "style-module--imgly--typo-h4--+jP14";
export var imglyTypoH5 = "style-module--imgly--typo-h5--rYtdl";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--b82zT";
export var imglyTypoIcon = "style-module--imgly--typo-icon--NvTVC";
export var imglyTypoLink = "style-module--imgly--typo-link--P6AmT";
export var imglyTypoOverline = "style-module--imgly--typo-overline--jVyBM";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--ewdX7";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--xi8gL";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--g7YjJ";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--Mx6Pj";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--Uhq1Z";
export var imglyTypoSubline = "style-module--imgly--typo-subline--A0ixi";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--xYeRg";
export var naviLabelIsLarge = "style-module--navi-label-is-large--GmgWH";
export var naviLabelIsSmall = "style-module--navi-label-is-small--y-JDH";
export var root = "style-module--root--ibjz4";
export var title = "style-module--title--fcTQp";